import SummaryAPI from "../Commson/summaryApi"
import Axios from "./axios"

const fetchUserDetails = async () => {
  try {
    const response = await Axios({
      ...SummaryAPI.userDetail,
    })

    if (response && response.data) {
      return response.data
    } else {
      console.warn("No response data received from API")
      return null
    }
  } catch (error) {
    console.error("Error fetching user details:", error)
    return null
  }
}

export default fetchUserDetails
